import { parseProfileFromIdToken } from "./token";

export const READ_ONLY_GROUPS = ["UserRead"] as const;

export const isReadOnlyGroups = (groups?: string[]) => {
  if (!groups?.length) {
    return false;
  }

  return READ_ONLY_GROUPS.some((group) => groups.includes(group));
};

export const isReadOnlyIdToken = (idToken?: string | null) => {
  if (!idToken) {
    return false;
  }

  try {
    const profile = parseProfileFromIdToken(idToken);
    return isReadOnlyGroups(profile.groups);
  } catch {
    return false;
  }
};
